module.exports = {"id":"156433","name":"Alfredo Talavera","rating":"77","photo":"./data/images/photos/1/156433.png","club":{"name":"Toluca","logo":"./data/images/clubs/Toluca.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlfredoTalavera0.json
// module id = 286
// module chunks = 0